
export const interactiveFeatures = {
  title: "Növeld az elköteleződést interaktivitással",
  subtitle: "Interaktív eszközök",
  description: "Platformunk interaktív funkcióival növelheted a felhasználói elkötelezettséget és a konverziós rátákat.",
  tryButton: "Kipróbálás",
  features: [
    {
      title: "Szavazások",
      description: "Interaktív szavazások a felhasználói vélemények gyűjtésére és a közösségi döntéshozatalra."
    },
    {
      title: "Értékelések",
      description: "Egyszerű értékelési rendszer a tartalmak és szolgáltatások minőségének visszajelzésére."
    },
    {
      title: "Kvízek",
      description: "Interaktív kvízek az elköteleződés növelésére és a tudás tesztelésére."
    },
    {
      title: "Értesítések",
      description: "Valós idejű értesítések, amelyek segítik a felhasználói aktivitás fenntartását."
    },
    {
      title: "Jutalomrendszer",
      description: "Gamifikált hűségpont rendszer, ami ösztönzi a felhasználókat a rendszeres visszatérésre."
    },
    {
      title: "Integrációk",
      description: "Külső szolgáltatások egyszerű integrálása a hatékonyabb munkafolyamatokért."
    }
  ],
  stats: {
    engagement: {
      title: "Elköteleződés növekedés",
      description: "Átlagos növekedés az oldal elköteleződési mutatóiban"
    },
    interaction: {
      title: "Interakciók száma",
      description: "Átlagos felhasználói interakciók havonta"
    },
    retention: {
      title: "Felhasználói megtartás",
      description: "Növekedés a felhasználói megtartási rátában"
    }
  }
};
